import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: false,
})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(html: string): SafeHtml {
    // nosemgrep: typescript.angular.security.audit.angular-domsanitizer.angular-bypasssecuritytrust
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
